"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

/* eslint-disable react/jsx-props-no-spreading */
var Element = function Element(_ref) {
  var attributes = _ref.attributes,
      children = _ref.children,
      element = _ref.element;
  var style = {
    textAlign: element.align
  };

  switch (element.type) {
    case "block-quote":
      return /*#__PURE__*/_react["default"].createElement("blockquote", (0, _extends2["default"])({
        style: style
      }, attributes), children);

    case "bulleted-list":
      return /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
        style: style
      }, attributes), children);

    case "heading-one":
      return /*#__PURE__*/_react["default"].createElement("h1", (0, _extends2["default"])({
        style: style
      }, attributes), children);

    case "heading-two":
      return /*#__PURE__*/_react["default"].createElement("h2", (0, _extends2["default"])({
        style: style
      }, attributes), children);

    case "list-item":
      return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
        style: style
      }, attributes), children);

    case "numbered-list":
      return /*#__PURE__*/_react["default"].createElement("ol", (0, _extends2["default"])({
        style: style
      }, attributes), children);

    default:
      return /*#__PURE__*/_react["default"].createElement("p", (0, _extends2["default"])({
        style: style
      }, attributes), children);
  }
};

var _default = Element;
exports["default"] = _default;